import {
  IWidgetSettings,
  IWidgetSettingsFormData
} from '@/models/Widget/settings';

export function transformWidgetSettingsToWidgetFormData(
  widgetSettings: IWidgetSettings
): IWidgetSettingsFormData {
  const {
    color,
    enabled,
    position,
    mobileSideSpacing,
    mobileBottomSpacing,
    desktopSideSpacing,
    desktopBottomSpacing,
    desktopWelcome,
    mobileWelcome,
    widgetStyleIcon,
    launcher,
    widgetStyleText,
    welcomeDescription,
    welcomeTitle,
    welcomeEnable = true
  } = widgetSettings;

  const response: IWidgetSettingsFormData = {
    enabled,
    widgetStyle: {
      icon: widgetStyleIcon,
      color,
      text: widgetStyleText,
      launcher: widgetStyleText ? 'both' : launcher || 'only'
    },
    placement: {
      positioning: position,
      mobile: {
        horizontally: mobileSideSpacing,
        vertically: mobileBottomSpacing
      },
      desktop: {
        horizontally: desktopSideSpacing,
        vertically: desktopBottomSpacing
      }
    },
    welcome: {
      desktopEnable: desktopWelcome,
      mobileEnable: mobileWelcome,
      title: welcomeTitle === undefined ? 'Hey there 👋' : welcomeTitle,
      description:
        welcomeDescription === undefined
          ? "You'll be rewarded with your loyalty Coins after checkout!"
          : welcomeDescription,
      enable: welcomeEnable
    },
    previewState: 'popover'
  };

  let welcomeVisibility = 'both';

  if (desktopWelcome && !mobileWelcome) welcomeVisibility = 'desktop';
  else if (!desktopWelcome && mobileWelcome) welcomeVisibility = 'mobile';

  response.welcome.visibility = welcomeVisibility;

  return response;
}
